export class GenerateEventSessionsModel {
  constructor() {}
}
